import { z } from 'zod';

/////////////////////////////////////////
// REFRESH TOKEN SCHEMA
/////////////////////////////////////////

export const RefreshTokenSchema = z.object({
  id: z.bigint(),
  refresh_token: z.string().nullable(),
  user_id: z.string().nullable(),
  data: z.string().nullable(),
  microsoft_data: z.string().nullable(),
  google_data: z.string().nullable(),
  facebook_data: z.string().nullable(),
  apple_data: z.string().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  expired_at: z.coerce.date().nullable(),
  last_access_token_created_at: z.coerce.date().nullable(),
})

export type RefreshToken = z.infer<typeof RefreshTokenSchema>

export default RefreshTokenSchema;
